import React from "react";
import { FaGoogle, FaShieldAlt, FaAward } from "react-icons/fa";
import {
  MdArrowBack,
  MdTrendingUp,
  MdVerifiedUser,
  MdCheckCircle,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/img/SimpleRenovate.svg";

const CREDIBILITY_BENEFITS = [
  {
    id: "trust",
    icon: MdTrendingUp,
    title: "More Trust",
    description: "Build stronger client relationships",
  },
  {
    id: "acceptance",
    icon: MdVerifiedUser,
    title: "Higher Acceptance",
    description: "Increased credibility signals",
  },
  {
    id: "win-rate",
    icon: FaAward,
    title: "Win Rate",
    description: "Convert more prospects",
  },
];

const SECURITY_POINTS = [
  "Reviews are imported using official platform APIs",
  "All data is encrypted and stored securely",
  "Compliant with platform terms of service",
  "Reviews remain linked to original sources",
];

const ImportReviewStepOne = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/professional/dashboard");
  };

  const handleGoogleImport = () => {
    navigate("/professional/import-reviews/step-2");
  };

  const handleReturnToDashboard = () => {
    navigate("/professional/dashboard");
  };

  return (
    <div className="import-reviews import-reviews--unified pro-app-page pro-app-page--muted">
      <div className="custom_container">
        <header className="import-reviews__toolbar">
          <button
            type="button"
            className="import-reviews__back"
            aria-label="Go back"
            onClick={handleBack}
          >
            <MdArrowBack size={24} />
          </button>
          <img src={logo} alt="SimpleRenovate" className="import-reviews__brand" />
          <h1 className="import-reviews__title">Import Reviews</h1>
        </header>

        <section className="import-reviews__boost-card">
          <div className="import-reviews__boost-icon" aria-hidden>
            <span>★</span>
          </div>
          <h2 className="import-reviews__boost-title">
            Boost Your Credibility Instantly
          </h2>
          <p className="import-reviews__boost-text">
            Import your existing reviews from Google, to build trust with new
            clients immediately.
          </p>

          <div className="import-reviews__benefits-grid">
            {CREDIBILITY_BENEFITS.map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.id} className="import-reviews__benefit">
                  <div className="import-reviews__benefit-icon" aria-hidden>
                    <Icon size={18} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              );
            })}
          </div>
        </section>

        <section className="import-reviews__secure-card">
          <div className="import-reviews__secure-icon" aria-hidden>
            <FaShieldAlt size={22} />
          </div>
          <h2 className="import-reviews__secure-title">Secure &amp; Compliant</h2>
          <p className="import-reviews__secure-text">
            We take security seriously. Your data is protected against APIs.
          </p>

          <ul className="import-reviews__secure-list">
            {SECURITY_POINTS.map((point) => (
              <li key={point}>
                <MdCheckCircle className="import-reviews__secure-check" aria-hidden />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="import-reviews__platforms">
          <h2 className="import-reviews__platforms-title">
            Select Platforms to Import From
          </h2>

          <div className="import-reviews__platform-row">
            <div className="import-reviews__platform-info">
              <FaGoogle className="import-reviews__google-icon" aria-hidden />
              <span>Google</span>
            </div>
            <button
              type="button"
              className="import-reviews__import-btn"
              onClick={handleGoogleImport}
            >
              Import
            </button>
          </div>
        </section>

        <button
          type="button"
          className="import-reviews__dashboard-btn"
          onClick={handleReturnToDashboard}
        >
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default ImportReviewStepOne;
